import {SET_EXTERNAL_URL_LOADING, SET_LOADING} from "./availableActions";
import {SetExternalUrlLoadingAction, SetLoadingAction} from "../../interfaces/store/actions/mask";

export const setLoading = (payload: boolean): SetLoadingAction => ({
    type: SET_LOADING,
    payload,
});

export const setExternalUrlLoading = (payload: boolean): SetExternalUrlLoadingAction => ({
    type: SET_EXTERNAL_URL_LOADING,
    payload,
});
